<template>
<router-link to="/work">
  <div id="canvasContainer">
    <canvas
      id="glslcc"
      class="GlslCanvas"
    ></canvas>
  </div>
</router-link>
</template>

<script lang="js">
import { Canvas } from 'glsl-canvas-js';

export default {
  name: 'WaterOpening',
  data() {
    return {
      url: process.env.VUE_APP_VPS_URL,
      shader: `
#ifdef GL_ES
precision mediump float;
#endif

uniform vec2 u_resolution;
uniform sampler2D u_tex0;
uniform float u_time; 


void main(  )
{
	vec2 uv = gl_FragCoord.xy / u_resolution.xy;
    vec2 warpUV = 5. * uv;

	float d = length( warpUV );
	vec2 st = warpUV*0.1 + 0.2*vec2(cos(0.071*u_time*2.+d),
								sin(0.073*u_time*1.-d));

    vec3 warpedCol = texture2D(u_tex0, st ).xyz * 2.0;
    float w = max( warpedCol.r, 0.85);
	
    vec2 offset = 0.01 * cos( warpedCol.rg * 3.14159 );
    vec3 col = texture2D(u_tex0, uv + offset ).rgb * vec3(0.5, 0.5, 0.5) ;
	col *= w*1.2;
	
	gl_FragColor = vec4( mix(col, texture2D(u_tex0, uv + offset ).rgb, 0.5),  1.0);
}
`,
canvasElement: null,
canvasContainer: null,
glsl: null,
water: {},
textureSrc: null
}
  },
  created() {
    let selfobject = this;
    this.$http.get(selfobject.url + '/background-images')
      .then(function (response) {
        selfobject.water = response["data"].water;
        selfobject.textureSrc = selfobject.url + selfobject.water.url;
        selfobject.runWebGL();
      })
  },
  methods: {
    runWebGL(){
      let VueThis = this;

      let glslOptions = {
        alpha: false,
        antialias: false,
        width: 10,
        height: 10,
        W: 10,
        H: 10,
        contextMode: "flat",
        desynchronized: true,
        animated: false,
        preserveDrawingBuffer: false,
        powerPreference: "low-power"
      };

      VueThis.canvasElement = document.getElementById('glslcc');
      VueThis.glsl = new Canvas(VueThis.canvasElement, glslOptions);

        let img = new Image(); 
        img.crossOrigin = "anonymous";
        window.console.log(VueThis.textureSrc);
        img.src = VueThis.textureSrc;

        VueThis.glsl.devicePixelRatio = 1.6;

        VueThis.glsl.setUniform('u_tex0', img );
        VueThis.glsl.load(VueThis.shader);
    }
  }
}
</script>

<style scoped>
#canvasContainer {
  position:absolute;
  width:100vw;
  height:100vh;
  top: 0;
  left:0;
}

canvas {
  position:relative;
  width:100%;
  height:100%;
}
</style>